import { mapGetters } from 'vuex';
import mvtListProperty from '@/common/components/mvtlistproperty/mvt-listproperty.vue';
import mvtLazyload from '@/common/components/mvtlazyload/mvt-lazyload.vue';

export default {
    name: 'guideArticleContent',
    inject: ['$eventBus'],
    props: {},
    components: {
        mvtListProperty,
        mvtLazyload,
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('guide', ['guide']),
    },
    methods: {
        getBody: function (v) {
            if (!v) return v;
            return v.replace(/&lt;\/script&gt;/g, '</script>');
        },
    },
};
